import React, { useState, useEffect } from 'react';

function CookiesNotification() {
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setShowNotification(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowNotification(false);
  };

  const handleDeclineCookies = () => {
    localStorage.setItem('cookiesAccepted', 'false');
    setShowNotification(false);
    // Clear any existing cookies (basic implementation)
    document.cookie.split(";").forEach(function(c) { 
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
    });
  };

  if (!showNotification) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-900 border-t border-gray-700 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-3 sm:space-y-0">
          <div className="flex-1 mr-0 sm:mr-4">
            <div className="flex items-start">
              <div className="text-2xl mr-3 mt-1">🍪</div>
              <div>
                <h3 className="text-white font-medium text-sm mb-1">
                  We use cookies to enhance your experience
                </h3>
                <p className="text-gray-300 text-xs leading-relaxed">
                  We use essential cookies for functionality and analytics cookies to understand how you use our platform. 
                  By continuing to use actuvo.ai, you consent to our cookie usage. Learn more in our{' '}
                  <button
                    onClick={() => window.open('/cookie-policy', '_blank')}
                    className="text-blue-400 hover:text-blue-300 underline"
                  >
                    Cookie Policy
                  </button>
                  {' '}and{' '}
                  <button
                    onClick={() => window.open('/privacy', '_blank')}
                    className="text-blue-400 hover:text-blue-300 underline"
                  >
                    Privacy Policy
                  </button>
                  .
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex space-x-3 w-full sm:w-auto">
            <button
              onClick={handleDeclineCookies}
              className="flex-1 sm:flex-none px-4 py-2 text-xs font-medium text-gray-300 hover:text-white border border-gray-600 hover:border-gray-500 rounded-md transition-colors duration-200"
            >
              Decline
            </button>
            <button
              onClick={handleAcceptCookies}
              className="flex-1 sm:flex-none px-4 py-2 text-xs font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors duration-200"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
      
      {/* Legal compliance notice */}
      <div className="bg-yellow-900 border-t border-yellow-700 px-4 sm:px-6 lg:px-8 py-2">
        <p className="text-yellow-100 text-xs text-center">
          <strong>⚠️ Risk Warning:</strong> Trading involves substantial risk of loss. Only invest money you can afford to lose.
        </p>
      </div>
    </div>
  );
}

export default CookiesNotification;